var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_8028_54769)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 12,
    rx: 16,
    ry: 12,
    fill: "url(#paint0_linear_8028_54769)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_8028_54769)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 12,
    rx: 13,
    ry: 10,
    fill: "url(#paint1_linear_8028_54769)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8028_54769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.5V5.5H15.239C15.3542 5.5 15.5915 5.50278 15.9508 5.50833C16.3102 5.51389 16.6559 5.53333 16.9881 5.56667C18.1678 5.68333 19.1678 6.01944 19.9881 6.575C20.8085 7.13056 21.4322 7.83611 21.8593 8.69167C22.2864 9.54722 22.5 10.4833 22.5 11.5C22.5 12.5167 22.2864 13.4528 21.8593 14.3083C21.4322 15.1639 20.8085 15.8694 19.9881 16.425C19.1678 16.9806 18.1678 17.3167 16.9881 17.4333C16.6559 17.4667 16.3102 17.4861 15.9508 17.4917C15.5915 17.4972 15.3542 17.5 15.239 17.5H10.5ZM13.3068 15.3667H15.239C15.422 15.3667 15.6695 15.3639 15.9814 15.3583C16.2932 15.3472 16.5746 15.3222 16.8254 15.2833C17.4627 15.1778 17.9814 14.9333 18.3814 14.55C18.7881 14.1667 19.0864 13.7056 19.2763 13.1667C19.4729 12.6278 19.5712 12.0722 19.5712 11.5C19.5712 10.9 19.4695 10.3306 19.2661 9.79167C19.0695 9.25278 18.7678 8.79722 18.361 8.425C17.9542 8.05278 17.4424 7.81667 16.8254 7.71667C16.5746 7.67222 16.2932 7.64722 15.9814 7.64167C15.6695 7.63611 15.422 7.63333 15.239 7.63333H13.3068V15.3667Z",
    fill: "url(#paint2_linear_8028_54769)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_8028_54769",
    x: 0,
    y: 0,
    width: 32,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.45332 0 0 0 0 0.45332 0 0 0 0 0.45332 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8028_54769"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8028_54769",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_8028_54769"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_8028_54769",
    x: 3,
    y: 2,
    width: 26,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8028_54769"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8028_54769",
    x: 10.5,
    y: 5.5,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8028_54769"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8028_54769",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8028_54769",
    x1: 4.64352,
    y1: 3.41981,
    x2: 20.9593,
    y2: 25.1742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8028_54769",
    x1: 3,
    y1: 2,
    x2: 22.3309,
    y2: 27.1301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8028_54769",
    x1: 10.5,
    y1: 5.5,
    x2: 23.3175,
    y2: 16.5519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#3C3849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201C2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerIcon);
export default __webpack_public_path__ + "static/media/dealer-icon.ef777129bc2128c52717f50caa66a463.svg";
export { ForwardRef as ReactComponent };